import { render } from "./error-page.vue?vue&type=template&id=fc29d09c&scoped=true&ts=true"
import script from "./error-page.vue?vue&type=script&lang=ts"
export * from "./error-page.vue?vue&type=script&lang=ts"

import "./error-page.vue?vue&type=style&index=0&id=fc29d09c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc29d09c"]])

export default __exports__